import { http } from "../client";
import { mapTrackObject } from "../tracks/map";
export var getTimetablePlaylistForToday = function (id) {
    return http.api
        .get("timetables/" + id + "/today_playlist")
        .then(function (response) { return response.data.data; })
        .then(function (data) {
        var _a, _b;
        return ({
            tracks: data.entries.map(mapTrackObject),
            interruptions: (_b = (_a = data.interruptions) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                offsetSeconds: item.offset_seconds,
                track: mapTrackObject(item.track),
            }); })) !== null && _b !== void 0 ? _b : [],
        });
    });
};
